import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiHome } from "react-icons/fi";
import {
  PiBuildingOffice,
  PiWarehouse,
  PiBuildingApartment,
} from "react-icons/pi";
import { BsShopWindow } from "react-icons/bs";
import { TbBuildingSkyscraper, TbChartArea } from "react-icons/tb";
import { GoSearch } from "react-icons/go";
import { IoFilterOutline } from "react-icons/io5";
import FilterPP from "../Filter/FilterPPage/FilterPP.jsx";
import PriceFilter from "../Filter/Price/PriceFIlter.jsx";
import AreaFilter from "../Filter/Area/AreaFilter.jsx";
import Modal from "react-modal";
import logoimage from "../../images/LogoMainSection.png";
import "./PropertyHeader.css";

const PropertyHeader = ({ setFilters }) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedPropertyType, setSelectedPropertyType] = useState(null);
  const [isForSale, setIsForSale] = useState(null);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const openFilter = () => setIsFilterOpen(true);
  const closeFilter = () => setIsFilterOpen(false);

  const applyPriceFilter = (minPrice, maxPrice) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      minPrice: minPrice || undefined,
      maxPrice: maxPrice || undefined,
    }));
  };

  const applyAreaFilter = (minArea, maxArea) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      minArea: minArea || undefined,
      maxArea: maxArea || undefined,
    }));
  };

  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    setSearch(searchValue);
    setFilters((prevFilters) => ({
      ...prevFilters,
      search: searchValue,
    }));
  };

  const handleClick = (isForSaleValue) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      isForSale:
        prevFilters.isForSale === isForSaleValue ? null : isForSaleValue,
    }));
  };

  const handlePropertyTypeFilter = (type) => {
    setSelectedPropertyType((prevType) => (prevType === type ? null : type));
    setFilters((prevFilters) => ({
      ...prevFilters,
      propertyType: selectedPropertyType === type ? null : type,
    }));
  };

  const applyFilterHandler = (filterValues) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      propertyType: filterValues.propertyType || undefined,
      minPrice:
        filterValues.minPrice !== "" ? filterValues.minPrice : undefined,
      maxPrice:
        filterValues.maxPrice !== "" ? filterValues.maxPrice : undefined,
      minArea: filterValues.minArea !== "" ? filterValues.minArea : undefined,
      maxArea: filterValues.maxArea !== "" ? filterValues.maxArea : undefined,
      bedrooms: filterValues.bedrooms || undefined,
      bathrooms: filterValues.bathrooms || undefined,
      orientation: filterValues.orientation || undefined,
      furniture: filterValues.furniture || undefined,
      heatingSystem: filterValues.heatingSystem || undefined,
      additionalFeatures: filterValues.additionalFeatures.length
        ? filterValues.additionalFeatures
        : undefined,
      hasOwnershipDocument: filterValues.hasOwnershipDocument || undefined,
      floorLevel: filterValues.floorLevel || undefined,
      country: filterValues.country || undefined,
      city: filterValues.city || undefined,
      neighborhood: filterValues.neighborhood || undefined,
      builder: filterValues.builder || undefined,
      complex: filterValues.complex || undefined,
    }));
  };

  const handleRedirect = () => navigate("/contact-us");
  const handleHomeRedirect = () => navigate("/");

const [isActiveRent, setIsActiveRent] = useState(false);
const [isActiveSell, setIsActiveSell] = useState(false);

const handleSellButtonClick = () => {
  setIsActiveSell((prev) => {
    const newState = !prev; // Toggle the state
    setIsActiveRent(false); // Ensure the rent button is not active when sell is active
    setFilters((prevFilters) => ({
      ...prevFilters,
      isForSale: newState ? true : null, // Update the filter for sell
    }));
    return newState;
  });
};

const handleRentButtonClick = () => {
  setIsActiveRent((prev) => {
    const newState = !prev; // Toggle the state
    setIsActiveSell(false); // Ensure the sell button is not active when rent is active
    setFilters((prevFilters) => ({
      ...prevFilters,
      isForSale: newState ? false : null, // Update the filter for rent
    }));
    return newState;
  });
};
  return (
    <>
      <div className="top-header-component">
          <div className="logo-component" onClick={handleHomeRedirect}>
            <img src={logoimage} alt="Real Estate Logo" />
            <h3>REAL-ESTATE</h3>
          </div>

          <div className="search-bar-component">
            <input
              type="search"
              placeholder="Kërko..."
              value={search}
              onChange={handleSearchChange}
            />
            <span className="search-icon-component">
              <GoSearch />
            </span>
          </div>

        <div
          className=""
          id="top-header-right-component"
        >
          <a onClick={handleRedirect} className="action-link-component">
            Ofroni Pronën Tuaj
          </a>
        </div>
      </div>

      <div className="bottom-header-component">
        <div className="button-group-component">
          <button
            className="filter-button-component"
            onClick={(() => handleClick(true), handleSellButtonClick)}
            style={{
              border: isActiveSell ? "1px solid grey " : "1px solid #ccc",
              backgroundColor: isActiveSell ? " #e7880c" : "#f8f8f8",
              color: isActiveSell ? "white" : "rgb(80, 78, 75)",
            }}
          >
            {isActiveSell ? "" : ""}
            Në Shitje
          </button>
          <button
            className="filter-button-component"
            onClick={(() => handleClick(false), handleRentButtonClick)}
            style={{
              border: isActiveRent ? "1px solid grey " : "1px solid #ccc",
              backgroundColor: isActiveRent ? "rgb(231, 191, 12)" : "#f8f8f8",
              color: isActiveRent ? "white" : "rgb(80, 78, 75)",
            }}
          >
            {isActiveRent ? "" : ""}
            Me Qera
          </button>
        </div>

        <div className="property-icons-header-component">
          {[
            { type: "House", icon: <FiHome />, label: "Shtëpi" },
            {
              type: "Apartment",
              icon: <PiBuildingApartment />,
              label: "Banesa",
            },
            { type: "Office", icon: <PiBuildingOffice />, label: "Zyre" },
            { type: "Store", icon: <BsShopWindow />, label: "Lokale" },
            { type: "Land", icon: <TbChartArea />, label: "Troje" },
            { type: "Warehouse", icon: <PiWarehouse />, label: "Depo" },
            {
              type: "Building",
              icon: <TbBuildingSkyscraper />,
              label: "Objekte",
            },
          ].map(({ type, icon, label }) => (
            <div
              key={type}
              className={`icon-component ${
                selectedPropertyType === type ? "active-icon" : ""
              }`}
              onClick={() => handlePropertyTypeFilter(type)}
            >
              {icon}
              <p>{label}</p>
            </div>
          ))}
        </div>

        <div className="filter-options-component">
          <PriceFilter applyPriceFilter={applyPriceFilter} />
          <AreaFilter applyAreaFilter={applyAreaFilter} />
          <button className="filter-button-1-component" onClick={openFilter}>
            <IoFilterOutline /> Filter
          </button>

          <Modal
            isOpen={isFilterOpen}
            onRequestClose={closeFilter}
            className="modal-content-component"
            overlayClassName="modal-overlay-component"
          >
            <FilterPP applyFilters={applyFilterHandler} onClose={closeFilter} />
          </Modal>
        </div>
      </div>
    </>
  );
};

export default PropertyHeader;
